import moment from 'moment/moment';
import { format } from 'date-fns';

export const getTodayDate = () => {
    return moment(new Date())
        .format('YYYY-MM-DD');
};

export const getTodayPlusDays = (days) => {
    return moment(new Date()).add(days, 'd')
        .format('YYYY-MM-DD');
};

export const toDateString = (date, dateFormat) => {
    return date != null && date !== '' && date !== ' '
        ? format(date, dateFormat)
        : null;
};

export const getMonthStart = () => {
    return moment()
        .startOf('month')
        .format('YYYY-MM-DD');
};